
















import { defineComponent, PropType } from '@vue/composition-api';
import { VueConstructor } from 'vue';

export default defineComponent({
	props: {
		tag: {
			type: [String, Object] as PropType<null | string | VueConstructor>,
			default: 'a',
		},
		hasBorder: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
});
